const templateVariables = {
  name: 'libraryMainsite-1.3.0',
  locate: 'vn',
  folderUse: [
    'main',
  ],
  generateFile: ['frame1'],
  H5: false,
  onlyPC: false,
  scaleWidthPC: 0,
  scaleWidthMB: 0,
  scssVariable: {
    minWidthPC: '0',
    maxWidthMB: '0',
  }
};

module.exports = templateVariables;